module.exports = __webpack_public_path__ + "img/wxqrcode.7161f226.png";